import * as Sentry from '@sentry/angular-ivy'

export function initSentry(
  dsn: string,
  isProduction: boolean,
  isLocalhost: boolean,
) {
  Sentry.init({
    dsn: dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
      }),
    ],

    // Performance Monitoring
    // Capture 10% in production, 100% in staging
    tracesSampleRate: isProduction ? 0.1 : 1.0,

    // Trace only this targets
    tracePropagationTargets: isLocalhost
      ? undefined
      : ['https://staging.orderpod.app/api/', 'https://orderpod.app/api/'],

    // Session Replay
    // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysSessionSampleRate: 0.25,
    // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event, hint) {
      const message = (hint?.originalException as any)?.message
      const messageCodeMatch = message?.match(/: (\d{1,3}) /)
      const messageCode = messageCodeMatch
        ? parseInt(messageCodeMatch[1], 10)
        : null

      if (
        (messageCode !== null && greenStatusCodes(messageCode)) ||
        `${message}`.includes('<unknown>')
      ) {
        return null
      }

      let subtitle: string | undefined

      if ((event.exception?.values?.length ?? 0) > 0) {
        subtitle = event.exception?.values?.[0].value
      } else if (event.message) {
        subtitle = event.message
      }

      const subtitleCodeMatch = subtitle?.match(/: (\d{1,3}) /)
      const subtitleCode = subtitleCodeMatch
        ? parseInt(subtitleCodeMatch[1], 10)
        : null

      if (subtitleCode !== null && greenStatusCodes(subtitleCode)) {
        return null
      }

      return event
    },
  })
}

export function greenStatusCodes(code: number): boolean {
  if (
    code === 0 ||
    (code >= 401 && code <= 412) ||
    code === 422 ||
    (code >= 500 && code <= 504)
  ) {
    return true
  }
  return false
}
